import React, { useCallback, useEffect, useMemo, useState } from "react";
import { API_BASE } from "../api/config";

const API = `${API_BASE}/datev/api`;

const S = {
  page: { maxWidth: 1200, margin: "0 auto", padding: "24px 20px 60px", fontFamily: "inherit", color: "var(--color-gray-800)" },
  h1: { fontSize: "1.5rem", margin: "0 0 4px" },
  sub: { color: "var(--color-gray-600)", margin: "0 0 20px", fontSize: "0.9rem" },
  card: { background: "var(--bg-card)", border: "1px solid var(--color-gray-200)", borderRadius: 10, padding: 18, marginBottom: 18, boxShadow: "0 1px 3px rgba(0,0,0,0.08)" },
  cardTitle: { fontSize: "1.05rem", fontWeight: 600, margin: "0 0 12px", color: "var(--color-gray-800)" },
  row: { display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" },
  label: { fontSize: "0.85rem", color: "var(--color-gray-700)", fontWeight: 600 },
  input: { padding: "7px 10px", border: "1px solid var(--color-gray-300)", borderRadius: 6, fontSize: "0.9rem" },
  btn: { padding: "8px 16px", border: "1px solid var(--color-gray-300)", borderRadius: 6, background: "var(--color-gray-100)", color: "var(--color-gray-800)", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 },
  btnPrimary: { padding: "8px 16px", border: "none", borderRadius: 6, background: "var(--color-success)", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 },
  btnDanger: { padding: "8px 16px", border: "none", borderRadius: 6, background: "var(--color-error)", color: "#fff", cursor: "pointer", fontSize: "0.9rem", fontWeight: 600 },
  table: { width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", color: "var(--color-gray-800)" },
  th: { textAlign: "left", padding: "7px 10px", borderBottom: "2px solid var(--color-gray-300)", color: "var(--color-gray-700)", whiteSpace: "nowrap" },
  td: { padding: "6px 10px", borderBottom: "1px solid var(--color-gray-200)", verticalAlign: "top" },
  badge: (bg, fg) => ({ display: "inline-block", padding: "2px 8px", borderRadius: 10, fontSize: "0.75rem", fontWeight: 600, background: bg, color: fg, whiteSpace: "nowrap" }),
  warn: { background: "var(--color-warning-bg)", border: "1px solid var(--color-warning)", borderRadius: 6, padding: "8px 12px", fontSize: "0.85rem", color: "var(--color-warning)", marginBottom: 8 },
  err: { background: "var(--color-error-bg)", border: "1px solid var(--color-error)", borderRadius: 6, padding: "8px 12px", fontSize: "0.85rem", color: "var(--color-error)", marginBottom: 8 },
  info: { background: "var(--color-info-bg)", border: "1px solid var(--color-info)", borderRadius: 6, padding: "8px 12px", fontSize: "0.85rem", color: "var(--color-info)", marginBottom: 8 },
  groupHead: { display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", background: "var(--color-gray-100)", borderRadius: 6, cursor: "pointer", marginTop: 10 },
  fileRow: { display: "flex", alignItems: "center", gap: 10, padding: "6px 10px 6px 30px", borderBottom: "1px solid var(--color-gray-200)", fontSize: "0.85rem" },
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 },
  overlayBox: { background: "var(--bg-card)", border: "1px solid var(--color-gray-200)", borderRadius: 12, padding: "28px 36px", textAlign: "center", boxShadow: "0 8px 30px rgba(0,0,0,0.35)", maxWidth: 360 },
  spinner: { width: 44, height: 44, margin: "0 auto 16px", border: "4px solid var(--color-gray-200)", borderTopColor: "var(--color-success)", borderRadius: "50%", animation: "datevspin 0.8s linear infinite" },
};

function VersandOverlay({ anzahl }) {
  return (
    <div style={S.overlay}>
      <style>{"@keyframes datevspin{to{transform:rotate(360deg)}}"}</style>
      <div style={S.overlayBox}>
        <div style={S.spinner} />
        <div style={{ fontWeight: 600, fontSize: "1rem", color: "var(--color-gray-800)" }}>
          Versand an DATEV läuft...
        </div>
        <div style={{ fontSize: "0.85rem", color: "var(--color-gray-600)", marginTop: 6 }}>
          {anzahl > 0 ? `${anzahl} Datei(en)` : "Alle zugeordneten Dateien"} werden gesendet,
          archiviert und aus Dropbox entfernt. Bitte warten, das Fenster nicht schließen.
        </div>
      </div>
    </div>
  );
}

/* Welle 51: Kleiner Anzeiger unten rechts, solange eine Aktion läuft. Vorher
   wurden die Knöpfe nur ausgegraut — dann war nicht erkennbar, ob überhaupt
   noch etwas passiert. */
function ArbeitetHinweis({ text }) {
  if (!text) return null;
  return (
    // bottom 136: unten rechts sitzen Ghost und Monitoring — sonst verdeckt.
    <div style={{
      position: "fixed", right: 20, bottom: 136, zIndex: 900,
      display: "flex", alignItems: "center", gap: 10,
      background: "var(--bg-card)", border: "1px solid var(--color-info)",
      borderRadius: 8, padding: "10px 14px", maxWidth: 380,
      boxShadow: "0 2px 10px rgba(0,0,0,0.18)", fontSize: "0.85rem",
      color: "var(--color-gray-800)",
    }}>
      <Spinner />
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {text}
      </span>
    </div>
  );
}

function Spinner({ groesse = 15 }) {
  return (
    <>
      <style>{"@keyframes imhoDreh{to{transform:rotate(360deg)}}"}</style>
      <span style={{
        display: "inline-block", width: groesse, height: groesse, flexShrink: 0,
        border: "2px solid var(--color-gray-300)",
        borderTopColor: "var(--color-info)", borderRadius: "50%",
        animation: "imhoDreh 0.8s linear infinite",
      }} />
    </>
  );
}

function statusBadge(status) {
  const map = {
    geplant: ["var(--color-info-bg)", "var(--color-info)"],
    ok: ["var(--color-success-bg)", "var(--color-success)"],
    kein_mapping: ["var(--color-error-bg)", "var(--color-error)"],
    fehler: ["var(--color-error-bg)", "var(--color-error)"],
    zu_gross: ["var(--color-error-bg)", "var(--color-error)"],
    gesendet_archiv_fehler: ["var(--color-warning-bg)", "var(--color-warning)"],
    gesendet_nach_gesendet: ["var(--color-warning-bg)", "var(--color-warning)"],
    uebersprungen: ["var(--color-gray-100)", "var(--color-gray-600)"],
    // Welle 50: Rückkanal
    warte_bestaetigung: ["var(--color-info-bg)", "var(--color-info)"],
    abgelehnt: ["var(--color-error-bg)", "var(--color-error)"],
    zieladresse_gesperrt: ["var(--color-error-bg)", "var(--color-error)"],
    ohne_antwort: ["var(--color-warning-bg)", "var(--color-warning)"],
  };
  const [bg, fg] = map[status] || ["var(--color-gray-100)", "var(--color-gray-600)"];
  return <span style={S.badge(bg, fg)}>{status || "-"}</span>;
}

function typBadge(typ) {
  if (typ === "rechnungsausgang")
    return <span style={S.badge("var(--color-warning-bg)", "var(--color-warning)")}>Ausgang</span>;
  return <span style={S.badge("var(--color-info-bg)", "var(--color-info)")}>Eingang</span>;
}

function fmtBytes(n) {
  if (n == null) return "-";
  if (n > 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${Math.round(n / 1024)} KB`;
}

function fmtDatum(v) {
  return v ? new Date(v).toLocaleString("de-DE") : "nie";
}

export default function DatevVersandPage() {
  const [config, setConfig] = useState(null);
  const [configMsg, setConfigMsg] = useState("");
  const [smtp, setSmtp] = useState(null);
  const [smtpLoading, setSmtpLoading] = useState(false);

  const [vorschau, setVorschau] = useState(null);
  const [vorschauLoading, setVorschauLoading] = useState(false);

  const [mappingData, setMappingData] = useState(null);
  const [mappingError, setMappingError] = useState("");
  const [mappingOpen, setMappingOpen] = useState(false);
  const [syncMsg, setSyncMsg] = useState("");
  const [syncLoading, setSyncLoading] = useState(false);

  const [logRows, setLogRows] = useState([]);
  const [logOpen, setLogOpen] = useState(false);

  const [laufErgebnis, setLaufErgebnis] = useState(null);
  const [laufLoading, setLaufLoading] = useState(false);
  const [laufAnzahl, setLaufAnzahl] = useState(0);
  const [fehler, setFehler] = useState("");

  const [selected, setSelected] = useState(new Set());
  const [collapsed, setCollapsed] = useState(new Set());

  // Welle 50: Rückkanal — was hat DATEV zu den gesendeten Belegen gesagt?
  const [rueck, setRueck] = useState(null);
  const [rueckLoading, setRueckLoading] = useState(false);
  const [rueckMsg, setRueckMsg] = useState("");
  // Welle 51: `laeuft` ist der Anzeigetext (wechselt beim Warten mit),
  // `aktiveDatei` merkt sich, welcher Zeilen-Knopf gedrückt wurde — dessen
  // Spinner soll bis zum Schluss durchlaufen, auch während des Wartens.
  const [laeuft, setLaeuft] = useState("");
  const [aktiveDatei, setAktiveDatei] = useState("");

  const ladeConfig = useCallback(async () => {
    try {
      const r = await fetch(`${API}/config`);
      setConfig(await r.json());
    } catch (e) {
      setFehler(`Config nicht ladbar: ${e.message}`);
    }
  }, []);

  const ladeVorschau = useCallback(async () => {
    setVorschauLoading(true);
    setFehler("");
    try {
      const r = await fetch(`${API}/vorschau`);
      const d = await r.json();
      setVorschau(d);
      setSelected(new Set()); // Auswahl passt sich der neuen Liste an
    } catch (e) {
      setFehler(`Vorschau fehlgeschlagen: ${e.message}`);
    } finally {
      setVorschauLoading(false);
    }
  }, []);

  useEffect(() => { ladeConfig(); ladeVorschau(); }, [ladeConfig, ladeVorschau]);
  // Welle 50: Der Rückkanal-Stand wird beim Öffnen der Seite mitgeladen —
  // abgelehnte Belege sollen sofort ins Auge fallen, nicht erst auf Klick.
  useEffect(() => { ladeRueckmeldungen(); }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const speichereConfig = async (felder) => {
    setConfigMsg("");
    try {
      const r = await fetch(`${API}/config`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(felder),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      setConfig((prev) => ({ ...prev, ...d.config }));
      setConfigMsg("Gespeichert");
      setTimeout(() => setConfigMsg(""), 2000);
    } catch (e) {
      setConfigMsg(`Fehler: ${e.message}`);
    }
  };

  const pruefeSmtp = async () => {
    setSmtpLoading(true);
    try {
      const r = await fetch(`${API}/smtp-check`);
      setSmtp(await r.json());
    } catch (e) {
      setSmtp({ ok: false, fehler: e.message });
    } finally {
      setSmtpLoading(false);
    }
  };

  const abgleichSheet = async () => {
    setSyncLoading(true);
    setSyncMsg("");
    try {
      const r = await fetch(`${API}/mapping/sync`, { method: "POST" });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      setSyncMsg(`${d.count} Mandanten abgeglichen`);
      if (mappingOpen) ladeMapping();
      ladeVorschau(); // Zuordnung neu berechnen
    } catch (e) {
      setSyncMsg(`Fehler: ${e.message}`);
    } finally {
      setSyncLoading(false);
    }
  };

  const ladeMapping = async () => {
    setMappingError("");
    setMappingOpen(true);
    try {
      const r = await fetch(`${API}/mapping`);
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      setMappingData(d);
    } catch (e) {
      setMappingData(null);
      setMappingError(String(e.message || e));
    }
  };

  const ladeLog = async () => {
    setLogOpen(true);
    try {
      const r = await fetch(`${API}/log?limit=200`);
      const d = await r.json();
      setLogRows(d.log || []);
    } catch (e) {
      setFehler(`Log nicht ladbar: ${e.message}`);
    }
  };

  // Gruppierung der Vorschau nach Mandant/Objekt + Sammelgruppe „Nicht zugeordnet".
  const { gruppen, keinMapping } = useMemo(() => {
    const positionen = (vorschau || {}).positionen || [];
    const map = {};
    const offen = [];
    for (const p of positionen) {
      if (p.status === "kein_mapping") { offen.push(p); continue; }
      const key = p.objekt || "?";
      if (!map[key]) map[key] = { objekt: key, mandant: p.mandant || "", files: [] };
      map[key].files.push(p);
    }
    const gruppen = Object.values(map).sort((a, b) => a.objekt.localeCompare(b.objekt));
    return { gruppen, keinMapping: offen };
  }, [vorschau]);

  const alleDateien = useMemo(
    () => gruppen.flatMap((g) => g.files.map((f) => f.datei)),
    [gruppen]
  );

  const toggleSelect = (datei) => {
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(datei) ? next.delete(datei) : next.add(datei);
      return next;
    });
  };
  const toggleGroup = (files) => {
    const paths = files.map((f) => f.datei);
    const allChecked = paths.every((p) => selected.has(p));
    setSelected((prev) => {
      const next = new Set(prev);
      paths.forEach((p) => (allChecked ? next.delete(p) : next.add(p)));
      return next;
    });
  };
  const toggleCollapse = (key) => {
    setCollapsed((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };
  const selectAll = () => setSelected(new Set(alleDateien));
  const selectNone = () => setSelected(new Set());
  const collapseAll = () => setCollapsed(new Set(gruppen.map((g) => g.objekt)));
  const expandAll = () => setCollapsed(new Set());

  const starteLauf = async (dateien, beschreibung) => {
    setFehler("");
    setLaufErgebnis(null);
    const ok = window.confirm(
      `Echter Versand an die DATEV-Adressen: ${beschreibung}.\n` +
      "Nach Versand werden die Dateien auf der Synology archiviert und aus Dropbox gelöscht. Fortfahren?"
    );
    if (!ok) return;
    setLaufAnzahl(dateien.length);
    setLaufLoading(true);
    try {
      const r = await fetch(`${API}/trigger`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dry_run: false, dateien }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      setLaufErgebnis(d);
      ladeConfig();
      ladeVorschau();       // Liste neu (gesendete Dateien sind weg)
      if (logOpen) ladeLog();
    } catch (e) {
      setFehler(`Lauf fehlgeschlagen: ${e.message}`);
    } finally {
      setLaufLoading(false);
    }
  };

  const ladeRueckmeldungen = async () => {
    try {
      const r = await fetch(`${API}/rueckmeldungen`);
      const d = await r.json();
      if (r.ok) setRueck(d);
    } catch (e) {
      /* stilles Scheitern: der Rest der Seite soll trotzdem laufen */
    }
  };

  // Antworten von DATEV abholen und die Warteschlange abarbeiten.
  const nachlaufStarten = async () => {
    setRueckLoading(true);
    setLaeuft("Postfach wird auf Antworten von DATEV geprüft …");
    setRueckMsg("");
    try {
      const r = await fetch(`${API}/nachlauf`, { method: "POST" });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      const a = d.abruf || {}, n = d.nachlauf || {};
      setRueckMsg(
        `${a.geaendert || 0} neue Antworten (${a.bestaetigt || 0} bestätigt, ` +
        `${a.abgelehnt || 0} abgelehnt) · ${n.archiviert || 0} archiviert, ` +
        `${n.zurueckgeholt || 0} zurückgeholt`
      );
      ladeRueckmeldungen();
      ladeVorschau();
      if (logOpen) ladeLog();
    } catch (e) {
      setRueckMsg(`Abruf fehlgeschlagen: ${e.message}`);
    } finally {
      setRueckLoading(false);
      setLaeuft("");
    }
  };

  // Welle 51: sendet sofort erneut — ohne Angabe alle abgelehnten, mit
  // `dateien` gezielt einzelne. Eine frühere Ablehnung hält nichts auf.
  const erneutSenden = async (dateien = null) => {
    setRueckLoading(true);
    setAktiveDatei(dateien && dateien.length === 1 ? dateien[0] : "*alle*");
    setLaeuft(dateien && dateien.length === 1
      ? `Beleg geht an DATEV: ${dateien[0]}`
      : "Alle abgelehnten Belege gehen an DATEV …");
    setRueckMsg("");
    try {
      const r = await fetch(`${API}/erneut-senden`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dateien ? { dateien } : {}),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || r.status);
      const fehler = (d.positionen || []).filter((p) => p.status === "fehler");
      setRueckMsg(
        `${d.gesendet} erneut gesendet — warte auf die Antwort von DATEV …` +
        (fehler.length ? ` · ${fehler.length} konnte(n) nicht gesendet werden` : "")
      );
      if (d.gesendet > 0) {
        await warteAufAntwort(dateien);
      } else {
        ladeRueckmeldungen();
      }
    } catch (e) {
      setRueckMsg(`Erneut senden fehlgeschlagen: ${e.message}`);
    } finally {
      setRueckLoading(false);
      setLaeuft("");
      setAktiveDatei("");
    }
  };

  // DATEV antwortet meist in wenigen Sekunden. Das Warten übernimmt das
  // Backend: es hält eine IMAP-Verbindung offen und sieht alle zwei Sekunden
  // nach — und zwar nur nach den Antworten zu genau diesen Dateien, nicht zum
  // ganzen Posteingang. Hier wird nur so lange nachgefragt, bis alles da ist.
  const warteAufAntwort = async (dateien = null, maxSekunden = 90) => {
    if (!dateien || !dateien.length) {
      dateien = (rueck?.wartend || []).map((z) => z.datei_name);
      if (!dateien.length) { ladeRueckmeldungen(); return; }
    }
    let offen = [...dateien];
    let verstrichen = 0;
    while (offen.length && verstrichen < maxSekunden) {
      setLaeuft(offen.length === 1
        ? `DATEV prüft den Beleg — warte auf Antwort (${verstrichen}s)`
        : `DATEV prüft ${offen.length} Belege — warte auf Antwort (${verstrichen}s)`);
      try {
        const r = await fetch(`${API}/rueckmeldungen/warten`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ dateien: offen, max_sekunden: 20 }),
        });
        const d = await r.json();
        if (!r.ok) break;
        verstrichen += d.sekunden || 20;
        offen = d.offen || [];
        if ((d.gefunden || []).length) {
          const abgelehnt = d.gefunden.filter((g) => g.ergebnis === "abgelehnt");
          setRueckMsg(
            `Antwort von DATEV: ${d.gefunden.length - abgelehnt.length} bestätigt` +
            (abgelehnt.length
              ? `, ${abgelehnt.length} abgelehnt (${abgelehnt[0].grund})`
              : "")
          );
        }
      } catch (e) {
        break;
      }
    }
    // Der Posteingang wurde eben schon gezielt abgefragt — hier nur noch
    // einsortieren (bestätigte ins Archiv und aus Dropbox), nicht erneut lesen.
    setLaeuft("Beleg wird einsortiert: bestätigte ins Archiv …");
    await fetch(`${API}/nachlauf?abrufen=false`, { method: "POST" });
    ladeRueckmeldungen();
    ladeVorschau();
    if (offen.length) {
      setRueckMsg(`Noch keine Antwort zu ${offen.length} Beleg(en) — ` +
                  "sie wird beim nächsten Abruf nachgetragen.");
    }
  };

  const ergPositionen = (laufErgebnis || {}).positionen || [];

  return (
    <div style={S.page}>
      {laufLoading && <VersandOverlay anzahl={laufAnzahl} />}
      <ArbeitetHinweis text={laeuft} />
      <h1 style={S.h1}>DATEV-Versand</h1>
      <p style={S.sub}>
        Belege aus dem Dropbox-Ordner "#Datev hochladen" werden per E-Mail an die
        DATEV-Upload-Adressen des jeweiligen Mandanten geschickt (Zuordnung über
        den Präfix im Dateinamen). Steht an zweiter Stelle im Dateinamen eine
        Rechnungsnummer statt eines Datums, gilt der Beleg als Rechnungsausgang
        und geht an die Ausgangs-Adresse, sonst an die Rechnungseingang-Adresse.
        Nach dem Versand bleibt die Datei liegen, wo sie ist, bis DATEV
        geantwortet hat. Erst mit der Bestätigung wird sie auf der Synology
        archiviert und aus Dropbox entfernt. Wird sie abgelehnt, bleibt sie
        einfach im Ordner und geht am nächsten Tag automatisch wieder raus.
      </p>

      {fehler && <div style={S.err}>{fehler}</div>}

      {/* Welle 50: Rückmeldungen von DATEV. Vorher blieb unbemerkt, wenn ein
          Beleg abgelehnt wurde — die Antwortmails las niemand. */}
      {rueck && (rueck.anzahl_abgelehnt > 0 || (rueck.wartend || []).length > 0
                 || rueck.anzahl_gesperrt > 0) && (
        <div style={{
          ...S.card,
          borderLeft: rueck.anzahl_abgelehnt > 0
            ? "4px solid var(--color-error)" : "4px solid var(--color-info)",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div style={{ ...S.cardTitle, margin: 0 }}>Rückmeldungen von DATEV</div>
            {rueck.anzahl_abgelehnt > 0 && (
              <span style={S.badge("var(--color-error-bg)", "var(--color-error)")}>
                {rueck.anzahl_abgelehnt} abgelehnt
              </span>
            )}
            {(rueck.wartend || []).length > 0 && (
              <span style={S.badge("var(--color-info-bg)", "var(--color-info)")}>
                {rueck.wartend.length} wartet auf Antwort
              </span>
            )}
            <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
              <button style={{ ...S.btn, display: "flex", alignItems: "center", gap: 7 }}
                      onClick={nachlaufStarten} disabled={rueckLoading}>
                {laeuft.startsWith("Postfach") && <Spinner groesse={13} />}
                {laeuft.startsWith("Postfach") ? "Prüft …" : "Antworten abrufen"}
              </button>
              <button style={{ ...S.btn, display: "flex", alignItems: "center", gap: 7 }}
                      onClick={() => erneutSenden()}
                      disabled={rueckLoading || rueck.anzahl_abgelehnt === 0}>
                {aktiveDatei === "*alle*" && <Spinner groesse={13} />}
                {aktiveDatei === "*alle*" ? "Läuft …" : "Alle erneut senden"}
              </button>
            </div>
          </div>

          {rueckMsg && <div style={{ ...S.info, marginTop: 10 }}>{rueckMsg}</div>}

          {rueck.anzahl_gesperrt > 0 && (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Zieladressen mit zuletzt abgelehnten Belegen
              </div>
              <div style={{ fontSize: "0.85rem", color: "var(--color-gray-600)", marginBottom: 8 }}>
                DATEV sperrt Belegtyp-/Zieladress-Kombinationen zeitweilig, wenn die
                Zuordnung des Belegtyps geprüft werden muss — und gibt sie nach der
                Prüfung wieder frei. Der Versand läuft deshalb ganz normal weiter:
                abgelehnte Belege bleiben im Ordner und gehen am nächsten Tag
                automatisch erneut raus. Geht es länger nicht, in DATEV Unternehmen
                online die Belegtyp-Zuordnung dieser Adresse prüfen und freigeben.
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={S.table}>
                  <thead>
                    <tr>
                      <th style={S.th}>Zieladresse</th>
                      <th style={S.th}>Objekte</th>
                      <th style={S.th}>Mandant</th>
                      <th style={S.th}>Belege</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rueck.gesperrte_adressen.map((a) => (
                      <tr key={a.zieladresse}>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.8rem" }}>
                          {a.zieladresse}
                        </td>
                        <td style={S.td}>{a.objekte.join(", ")}</td>
                        <td style={S.td}>{a.mandanten.join(", ")}</td>
                        <td style={S.td}>{a.dateien}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {rueck.anzahl_abgelehnt > 0 && (
            <div style={{ marginTop: 14 }}>
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                Abgelehnte Belege ({rueck.anzahl_abgelehnt})
              </div>
              <div style={{ overflowX: "auto", maxHeight: 320, overflowY: "auto" }}>
                <table style={S.table}>
                  <thead>
                    <tr>
                      <th style={S.th}>Datei</th>
                      <th style={S.th}>Objekt</th>
                      <th style={S.th}>Grund</th>
                      <th style={S.th}>Versuche</th>
                      <th style={S.th}>Gesendet</th>
                      <th style={S.th}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rueck.abgelehnt.map((z) => (
                      <tr key={z.id}>
                        <td style={S.td}>{z.datei_name}</td>
                        <td style={S.td}>{z.objekt_id}</td>
                        <td style={S.td}>{z.datev_grund || "—"}</td>
                        <td style={S.td}>{z.versuche}</td>
                        <td style={S.td}>{fmtDatum(z.gesendet_am)}</td>
                        <td style={S.td}>
                          <button
                            style={{ ...S.btn, padding: "4px 10px", fontSize: "0.8rem",
                                     display: "flex", alignItems: "center", gap: 6 }}
                            onClick={() => erneutSenden([z.datei_name])}
                            disabled={rueckLoading}
                            title="Diesen Beleg sofort noch einmal an DATEV schicken"
                          >
                            {aktiveDatei === z.datei_name && <Spinner groesse={12} />}
                            {aktiveDatei === z.datei_name ? "Läuft …" : "Nochmal senden"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Konfiguration */}
      <div style={S.card}>
        <div style={S.cardTitle}>Automatischer Versand</div>
        {config ? (
          <div style={S.row}>
            <label style={{ ...S.row, gap: 8, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={!!config.enabled}
                onChange={(e) => speichereConfig({ enabled: e.target.checked })}
              />
              <span style={S.label}>Automatischer Versand aktiv ({config.env})</span>
            </label>
            <span style={S.label}>Intervall:</span>
            <select
              style={S.input}
              value={config.versand_intervall_h ?? 24}
              onChange={(e) => speichereConfig({ versand_intervall_h: Number(e.target.value) })}
            >
              <option value={24}>Täglich</option>
              <option value={12}>Alle 12 Stunden</option>
              <option value={6}>Alle 6 Stunden</option>
              <option value={1}>Stündlich</option>
            </select>
            {(config.versand_intervall_h ?? 24) === 24 && (
              <>
                <span style={S.label}>Uhrzeit:</span>
                <select
                  style={S.input}
                  value={config.versand_stunde ?? 6}
                  onChange={(e) => speichereConfig({ versand_stunde: Number(e.target.value) })}
                >
                  {Array.from({ length: 24 }, (_, h) => (
                    <option key={h} value={h}>{String(h).padStart(2, "0")}:00 Uhr</option>
                  ))}
                </select>
              </>
            )}
            <span style={{ fontSize: "0.8rem", color: "var(--color-gray-600)" }}>
              Letzter Lauf: {fmtDatum(config.last_run)}
              {config.last_status ? ` (${config.last_status}, ok: ${config.last_ok}, Fehler: ${config.last_fehler})` : ""}
            </span>
            {configMsg && <span style={{ fontSize: "0.8rem", color: configMsg.startsWith("Fehler") ? "var(--color-error)" : "var(--color-success)" }}>{configMsg}</span>}
          </div>
        ) : (
          <span style={{ color: "var(--color-gray-600)" }}>Lade Konfiguration...</span>
        )}
        {config && config.last_error_msg && (
          <div style={{ ...S.err, marginTop: 10 }}>Letzter Fehler: {config.last_error_msg}</div>
        )}
      </div>

      {/* Verbindung + Abgleich */}
      <div style={S.card}>
        <div style={S.cardTitle}>Verbindung und Mapping</div>
        <div style={S.row}>
          <button style={S.btn} onClick={pruefeSmtp} disabled={smtpLoading}>
            {smtpLoading ? "Prüfe..." : "SMTP prüfen"}
          </button>
          {smtp && (
            smtp.ok
              ? <span style={S.badge("var(--color-success-bg)", "var(--color-success)")}>Verbindung ok ({smtp.user} über {smtp.host}:{smtp.port})</span>
              : <span style={S.badge("var(--color-error-bg)", "var(--color-error)")}>Fehler: {smtp.fehler}</span>
          )}
          <button style={S.btn} onClick={abgleichSheet} disabled={syncLoading}>
            {syncLoading ? "Gleiche ab..." : "Sheet abgleichen"}
          </button>
          {syncMsg && <span style={{ fontSize: "0.8rem", color: syncMsg.startsWith("Fehler") ? "var(--color-error)" : "var(--color-success)" }}>{syncMsg}</span>}
          <button style={S.btn} onClick={ladeMapping}>Mapping anzeigen</button>
          <button style={S.btn} onClick={ladeLog}>Log anzeigen</button>
          <button style={S.btn} onClick={ladeVorschau} disabled={vorschauLoading}>
            {vorschauLoading ? "Lade..." : "Liste aktualisieren"}
          </button>
        </div>
      </div>

      {/* Auswahl-Liste */}
      <div style={S.card}>
        <div style={S.cardTitle}>Dateien auswählen und senden</div>
        {vorschau && vorschau.status !== "ok" && vorschau.fehler_msg && (
          <div style={S.err}>{vorschau.status}: {vorschau.fehler_msg}</div>
        )}
        {(vorschau?.warnungen || []).map((w, i) => (
          <div key={i} style={S.warn}>{w}</div>
        ))}
        <div style={{ ...S.row, marginBottom: 10 }}>
          <button style={S.btn} onClick={selectAll} disabled={!alleDateien.length}>Alle</button>
          <button style={S.btn} onClick={selectNone} disabled={!selected.size}>Keine</button>
          <button style={S.btn} onClick={collapseAll} disabled={!gruppen.length}>Alle einklappen</button>
          <button style={S.btn} onClick={expandAll} disabled={!collapsed.size}>Alle ausklappen</button>
          <span style={{ fontSize: "0.85rem", color: "var(--color-gray-700)" }}>
            {selected.size} ausgewählt · {alleDateien.length} zugeordnet · {keinMapping.length} nicht zugeordnet
          </span>
          <div style={{ display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" }}>
            <button
              style={{ ...S.btnDanger, opacity: selected.size && !laufLoading ? 1 : 0.5 }}
              onClick={() => starteLauf(Array.from(selected), `${selected.size} ausgewählte Datei(en)`)}
              disabled={!selected.size || laufLoading}
            >
              {laufLoading ? "Läuft..." : `Ausgewählte senden (${selected.size})`}
            </button>
            <button
              style={{ ...S.btnDanger, opacity: alleDateien.length && !laufLoading ? 1 : 0.5 }}
              onClick={() => starteLauf([], `alle ${alleDateien.length} zugeordneten Dateien`)}
              disabled={!alleDateien.length || laufLoading}
            >
              Alle zugeordneten senden
            </button>
          </div>
        </div>

        {!gruppen.length && !keinMapping.length && (
          <span style={{ color: "var(--color-gray-600)", fontSize: "0.85rem" }}>
            {vorschauLoading ? "Lade Liste..." : "Keine Dateien im Ordner."}
          </span>
        )}

        {gruppen.map((g) => {
          const paths = g.files.map((f) => f.datei);
          const allChecked = paths.every((p) => selected.has(p));
          const someChecked = !allChecked && paths.some((p) => selected.has(p));
          const isCollapsed = collapsed.has(g.objekt);
          const hatAusgang = g.files.some((f) => f.typ === "rechnungsausgang");
          return (
            <div key={g.objekt}>
              <div style={S.groupHead} onClick={() => toggleCollapse(g.objekt)}>
                <input
                  type="checkbox"
                  checked={allChecked}
                  ref={(el) => { if (el) el.indeterminate = someChecked; }}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => toggleGroup(g.files)}
                />
                <span style={{ fontWeight: 700 }}>{g.objekt}</span>
                <span style={{ color: "var(--color-gray-700)" }}>{g.mandant || "—"}</span>
                {hatAusgang && <span style={S.badge("var(--color-warning-bg)", "var(--color-warning)")}>enthält Ausgang</span>}
                <span style={S.badge("var(--color-info-bg)", "var(--color-info)")}>{g.files.length}</span>
                <span style={{ marginLeft: "auto", color: "var(--color-gray-600)" }}>{isCollapsed ? "▸" : "▾"}</span>
              </div>
              {!isCollapsed && g.files.map((f) => (
                <label key={f.datei} style={{ ...S.fileRow, cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={selected.has(f.datei)}
                    onChange={() => toggleSelect(f.datei)}
                  />
                  <span style={{ flex: 1 }}>{f.datei}</span>
                  {typBadge(f.typ)}
                  <span style={{ color: "var(--color-gray-600)", minWidth: 56, textAlign: "right" }}>{fmtBytes(f.groesse)}</span>
                </label>
              ))}
            </div>
          );
        })}

        {keinMapping.length > 0 && (
          <div style={{ marginTop: 14 }}>
            <div style={{ ...S.groupHead, background: "var(--color-error-bg)", cursor: "default" }}>
              <span style={{ fontWeight: 700, color: "var(--color-error)" }}>
                Nicht zugeordnet — bleibt in Dropbox
              </span>
              <span style={S.badge("var(--color-error-bg)", "var(--color-error)")}>{keinMapping.length}</span>
            </div>
            {keinMapping.map((f) => (
              <div key={f.datei} style={{ ...S.fileRow, opacity: 0.7 }}>
                <span style={{ flex: 1 }}>{f.datei}</span>
                <span style={{ color: "var(--color-gray-600)" }}>{f.objekt || "kein Präfix"}</span>
                <span style={{ color: "var(--color-error)", fontSize: "0.78rem" }}>{f.fehler}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Versand-Ergebnis */}
      {laufErgebnis && (
        <div style={S.card}>
          <div style={S.cardTitle}>Versand-Ergebnis</div>
          {laufErgebnis.status !== "ok" && laufErgebnis.fehler_msg && (
            <div style={S.err}>{laufErgebnis.status}: {laufErgebnis.fehler_msg}</div>
          )}
          {(laufErgebnis.warnungen || []).map((w, i) => (
            <div key={i} style={S.warn}>{w}</div>
          ))}
          <div style={{ ...S.row, marginBottom: 10, fontSize: "0.85rem", color: "var(--color-gray-700)" }}>
            <span style={S.badge("var(--color-success-bg)", "var(--color-success)")}>{laufErgebnis.anzahl_ok} gesendet</span>
            <span style={S.badge("var(--color-error-bg)", "var(--color-error)")}>{laufErgebnis.anzahl_fehler} Fehler</span>
          </div>
          <div style={{ overflowX: "auto", maxHeight: 420, overflowY: "auto" }}>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Datei</th>
                  <th style={S.th}>Objekt</th>
                  <th style={S.th}>Typ</th>
                  <th style={S.th}>Mandant</th>
                  <th style={S.th}>Zieladresse</th>
                  <th style={S.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {ergPositionen.filter((p) => p.status !== "kein_mapping").map((p, i) => (
                  <tr key={i}>
                    <td style={S.td}>{p.datei}</td>
                    <td style={S.td}>{p.objekt || "-"}</td>
                    <td style={S.td}>{typBadge(p.typ)}</td>
                    <td style={S.td}>{p.mandant || "-"}</td>
                    <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{p.zieladresse || "-"}</td>
                    <td style={S.td}>
                      {statusBadge(p.status)}
                      {p.fehler && <div style={{ color: "var(--color-error)", fontSize: "0.75rem", marginTop: 2 }}>{p.fehler}</div>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Mapping */}
      {mappingOpen && (
        <div style={S.card}>
          <div style={S.cardTitle}>Mandanten-Mapping (aus DB)</div>
          {mappingError && <div style={S.err}>{mappingError}</div>}
          {mappingData && (
            <>
              <div style={{ fontSize: "0.8rem", color: "var(--color-gray-600)", marginBottom: 10 }}>
                {mappingData.anzahl} Mandanten · zuletzt abgeglichen: {fmtDatum(mappingData.zuletzt_abgeglichen)}
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={S.table}>
                  <thead>
                    <tr>
                      <th style={S.th}>Obj-ID</th>
                      <th style={S.th}>Mandant</th>
                      <th style={S.th}>Rechnungseingang</th>
                      <th style={S.th}>Rechnungsausgang</th>
                      <th style={S.th}>Sonstige</th>
                      <th style={S.th}>Kasse</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(mappingData.mapping || {}).map(([obj, m]) => (
                      <tr key={obj}>
                        <td style={{ ...S.td, fontWeight: 600 }}>{obj}</td>
                        <td style={S.td}>{m.mandant || "-"}</td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{m.rechnungseingang || "-"}</td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{m.rechnungsausgang || "-"}</td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{m.sonstige || "-"}</td>
                        <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{m.kasse || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}

      {/* Log */}
      {logOpen && (
        <div style={S.card}>
          <div style={S.cardTitle}>Versand-Protokoll</div>
          {logRows.length === 0 ? (
            <span style={{ color: "var(--color-gray-600)", fontSize: "0.85rem" }}>Noch keine Einträge.</span>
          ) : (
            <div style={{ overflowX: "auto", maxHeight: 420, overflowY: "auto" }}>
              <table style={S.table}>
                <thead>
                  <tr>
                    <th style={S.th}>Zeitpunkt</th>
                    <th style={S.th}>Datei</th>
                    <th style={S.th}>Objekt</th>
                    <th style={S.th}>Typ</th>
                    <th style={S.th}>Zieladresse</th>
                    <th style={S.th}>Status</th>
                    <th style={S.th}>Archiv</th>
                    <th style={S.th}>Fehler</th>
                  </tr>
                </thead>
                <tbody>
                  {logRows.map((row) => (
                    <tr key={row.id}>
                      <td style={{ ...S.td, whiteSpace: "nowrap" }}>{fmtDatum(row.gesendet_am)}</td>
                      <td style={S.td}>{row.datei_name}</td>
                      <td style={S.td}>{row.objekt_id || "-"}</td>
                      <td style={S.td}>{row.typ === "rechnungsausgang" ? "Ausgang" : "Eingang"}</td>
                      <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.78rem" }}>{row.zieladresse || "-"}</td>
                      <td style={S.td}>{statusBadge(row.status)}</td>
                      <td style={{ ...S.td, fontFamily: "monospace", fontSize: "0.72rem" }}>{row.archiv_pfad || "-"}</td>
                      <td style={{ ...S.td, color: "var(--color-error)" }}>{row.fehler || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
